import {
    createEmpty,
    createEmptyData,
    datasetKey,
} from '../../scorecard.model';
import { ScorecardWidgetState } from '../pulse-widget.state';

import { createHistoryPosition } from './create-history-position';
import { getYourTeamEnabled } from './get-yourteam-enabled';
import { HistoryPositionNavigate } from './history-position-navigate.model';

export function navigateScorecardHistoryReducer(
    state: ScorecardWidgetState,
    historyPosNav: HistoryPositionNavigate,
): ScorecardWidgetState {
    try {
        // next scorecard history
        // TODO revise. may be null if data has not yet arrived
        const nextSh =
            state.scorecardHistory[state.selectedPeriodType.periodTypeId];

        let nextIndex = state.historyPos.index + historyPosNav.direction;
        nextIndex = Math.min(Math.max(0, nextIndex), nextSh.length - 1);

        // next scorecard
        const nextSc = nextSh[nextIndex];
        const key = datasetKey(
            state.selectedPeriodType.periodTypeId,
            nextSc.scorecardId,
        );
        const nextSelSc = {
            header: nextSc || createEmpty(),
            data: state.scorecardDataset[key] || createEmptyData(),
        };

        const historyPos = createHistoryPosition(nextSh, nextSelSc);

        const nextYtEnabled = getYourTeamEnabled(nextSelSc);

        return {
            ...state,
            selectedScorecardHistory: nextSh,
            selectedScorecard: nextSelSc,
            historyPos,
            yourTeamEnabled: nextYtEnabled,
        };
    } catch {
        return state;
    }
}
